import React from "react";
import { useSelector } from "react-redux";
import ConversionTable from "./conversionsTable";

export default function ConversionsTableHeader() {
  const conversions = useSelector((state) => state.multiLocation.conversions);

  return (
    <section className="section-table">
      <div className="table-wrapper-bottom">
        <div className="table-top leads-added">
          <div className="table-top-wrapper" style={{ minHeight: "91px" }}>
            <div className="title">
              <h2>{conversions.titles[0]}</h2>
            </div>
            <div className="metrics" style={{ width: "45%" }}>
              <p>{conversions.titles[1]}</p>
              <div className="sub-metrics">
                <p className="total">
                  <span>
                    <span>{conversions.leads_total}</span>
                    {conversions.leads_mom_total !== "0.0%" ? (
                      <span
                        className={`percent ${
                          conversions.leads_mom_total.indexOf("-") > -1 ? "negative" : "positive"
                        }`}
                      >
                        {conversions.leads_mom_total}
                      </span>
                    ) : (
                      ""
                    )}
                  </span>
                </p>
              </div>
              <div className="sub-metrics">
                <p>
                  Previous: <span>{conversions.leads_lm_total}</span>
                </p>
              </div>
              <div className="sub-metrics">
                <p>
                  Average: <span>{conversions.leads_total_average}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="table-top appointment">
          <div className="table-top-wrapper" style={{ minHeight: "91px" }}>
            <div className="title">
              <h2>{conversions.titles[2]}</h2>
              <p>{conversions.titles[3]}</p>
            </div>
            <div className="metrics" style={{ width: "45%" }}>
              <p>{conversions.titles[4]}</p>
              <div className="sub-metrics">
                <p className="total">
                  <span>
                    <span>{conversions.app_total}</span>
                    {conversions.app_mom_total !== "0.0%" ? (
                      <span
                        className={`percent ${
                          conversions.app_mom_total.indexOf("-") > -1 ? "negative" : "positive"
                        }`}
                      >
                        {conversions.app_mom_total}
                      </span>
                    ) : (
                      ""
                    )}
                  </span>
                </p>
              </div>
              <div className="sub-metrics">
                <p>
                  Previous:&nbsp;<span>{conversions.app_lm_total}</span>
                </p>
              </div>
              <div className="sub-metrics">
                <p>
                  Average:&nbsp;<span>{conversions.app_total_average}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="table-top show">
          <div className="table-top-wrapper" style={{ minHeight: "91px" }}>
            <div className="title">
              <h2>{conversions.titles[5]}</h2>
              <p>{conversions.titles[6]}</p>
            </div>
            <div className="metrics" style={{ width: "45%" }}>
              <p>{conversions.titles[7]}</p>
              <div className="sub-metrics">
                <p className="total">
                  <span>
                    <span>{conversions.show_total}</span>
                    {conversions.show_mom_total !== "0.0%" ? (
                      <span
                        className={`percent ${
                          conversions.show_mom_total.indexOf("-") > -1 ? "negative" : "positive"
                        }`}
                      >
                        {conversions.show_mom_total}
                      </span>
                    ) : (
                      ""
                    )}
                  </span>
                </p>
              </div>
              <div className="sub-metrics">
                <p>
                  Previous:&nbsp;<span>{conversions.show_lm_total}</span>
                </p>
              </div>
              <div className="sub-metrics">
                <p>
                  Average:&nbsp;<span>{conversions.show_total_average}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="table-top enrollment">
          <div className="table-top-wrapper" style={{ minHeight: "91px" }}>
            <div className="title">
              <h2>{conversions.titles[8]}</h2>
              <p>{conversions.titles[9]}</p>
            </div>
            <div className="metrics" style={{ width: "45%" }}>
              <p>{conversions.titles[10]}</p>
              <div className="sub-metrics">
                <p className="total">
                  <span>
                    <span>{conversions.enroll_total}</span>
                    {conversions.enroll_mom_total !== "0.0%" ? (
                      <span
                        className={`percent ${
                          conversions.enroll_mom_total.indexOf("-") > -1 ? "negative" : "positive"
                        }`}
                      >
                        {conversions.enroll_mom_total}
                      </span>
                    ) : (
                      ""
                    )}
                  </span>
                </p>
              </div>
              <div className="sub-metrics">
                <p>
                  Previous:&nbsp;<span>{conversions.enroll_lm_total}</span>
                </p>
              </div>
              <div className="sub-metrics">
                <p>
                  Average:&nbsp;<span>{conversions.enroll_total_average}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="table-wrapper conversion-table">
        <ConversionTable />
      </div>
    </section>
  );
}
